import { amountUtils, type Optional } from '@festina-life/core'
import { useCallback } from 'react'

import { useSettingsContext } from '../components/settingsProvider/settingsContext'

/**
 * Hook used for formatting amounts based on the current language and currency settings.
 */
export const useAmountFormatter = () => {
  const { language, currency } = useSettingsContext()
  const formatWithDecimals = useCallback(
    (value: Optional<number | string>) =>
      amountUtils.formatAmount({
        value,
        language,
        currency,
        isTwoDigitFraction: true,
      }),
    [language, currency],
  )

  const format = useCallback(
    (value: Optional<number | string>) =>
      amountUtils.formatAmount({
        value,
        language,
        currency,
        isTwoDigitFraction: false,
      }),
    [language, currency],
  )

  const formatUnitlessWithDecimals = useCallback(
    (value: Optional<number | string>) =>
      amountUtils.formatAmount({
        value,
        language,
        isTwoDigitFraction: true,
      }),
    [language],
  )

  const formatUnitless = useCallback(
    (value: Optional<number | string>) =>
      amountUtils.formatAmount({
        value,
        language,
        isTwoDigitFraction: false,
      }),
    [language],
  )

  return {
    format,
    formatWithDecimals,
    formatUnitless,
    formatUnitlessWithDecimals,
  }
}
